/**
 * Tiny pub/sub that lets the many Care triggers in the report share ONE hover card.
 * Triggers only post requests here; CareHoverCardHost (mounted once per table) owns all
 * timing, positioning and rendering. Nothing here touches React state, so hovering never
 * re-renders the table.
 */
const listeners = new Set();

export const careHoverStore = {
    subscribe(listener) {
        listeners.add(listener);
        return () => listeners.delete(listener);
    },
    /** payload: { anchorEl, data, source: 'hover' | 'focus' | 'click' } */
    open(payload) {
        listeners.forEach(l => l({ type: 'open', ...payload }));
    },
    close(anchorEl, source = 'hover') {
        listeners.forEach(l => l({ type: 'close', anchorEl, source }));
    },
    togglePin(payload) {
        listeners.forEach(l => l({ type: 'togglePin', ...payload }));
    }
};
